export default "__VITE_ASSET__CT4Wo6Wz__"